export default "__VITE_ASSET__DQV4$5bU__"